import configService from '../configService';
import {
  MentorAiState,
  UserDataLogin,
  LoginResponse,
  TokenResponse,
  BaseStructureGetUserInformation,
  ApiResponseStudentData,
  RootObjectQuestions,
} from './types';

export interface MentorAiInitOptions {
  testingPhase: boolean;
  coachBuild: boolean;
}

class MentorAiService {
  private state: MentorAiState = {
    serverID: '',
    baseUrl: '',
    baseUrlLLM: '',
    adminUser: '',
    adminPass: '',
    client: 'learnenglish',
    customerClient: '',
    botName: 'learnAssistant',
    assistantID: '',
    promptReference: '',
    loginUrl: '',
    obtainFullPromptURL: '',
    StudentInformationUrl: '',
    GetStudentInformationUrl: '',
    PatchStudentInformationUrl: '',
    GetUserInformationUrl: '',
    GetUserInfoUrl: '',
    GetCourseInfoUrl: '',
    CoursesUrl: '',
    MetricsUrl: '',
    QuestionsUrl: '',
    QuestionsBuddyUrl: '',
    GetQuestionsUrl: '',
    GetQuestionsBuddyUrl: '',
    UpdateStatusUrl: '',
    GetResourcesUrl: '',
    GetUserOauthUrl: '',
    UpdateTimeUrl: '',
    RefreshTokenUrl: '',
    reportConectionsUrl: '',
  };

  initialize({ testingPhase, coachBuild }: MentorAiInitOptions): MentorAiState {
    if (testingPhase) {
      this.state.serverID = '33389006-7800-4487-a49c-50c9680e5a8c';
      this.state.baseUrl = 'https://learnenglish.niimx.us/';
      this.state.adminUser = 'learnenglish';
      this.state.adminPass = 'rG)I@~[847Yg';
      this.state.customerClient = 'rRAR1dDlu8vA1qcSInadWg%3D%3D';

      if (coachBuild) {
        this.state.assistantID = 'f6982745-1580-4aa0-a65f-d70f038c9612';
        this.state.botName = 'Coach';
        this.state.promptReference = 'learnenglish-coach-dev';
      } else {
        this.state.botName = 'learnAssistant';
        this.state.promptReference = 'learnenglish-teacher-assistant-dev';
      }
    } else {
      this.state.serverID = '79872d75-784b-474f-9de6-7e9b08e64041';
      this.state.baseUrl = 'https://learnenglish.mentoraibot.com/';
      this.state.adminUser = 'learnenglish';
      this.state.adminPass = '%gm6v6+#j5B(';
      this.state.customerClient = '6T2TcKoIFKFSBss4n2%2Fj2A%3D%3D';

      if (coachBuild) {
        this.state.assistantID = 'b2a8ddd8-a7bd-4d51-b11a-76cd5fe0fb58';
        this.state.botName = 'Coach';
        this.state.promptReference = 'learnenglish-coach-pro';
      } else {
        this.state.botName = 'learnAssistant';
        this.state.promptReference = 'learnenglish-teacher-assistant-pro';
      }
    }

    this.state.baseUrlLLM = testingPhase
      ? 'https://llm-dev.aitopstaff.com'
      : 'https://llm.aitopstaff.com';

    this.state.obtainFullPromptURL = `${this.state.baseUrlLLM}/api/v1/bot/get_full_prompt/`;
    this.state.loginUrl = `${this.state.baseUrl}api/v1/login/`;
    this.state.StudentInformationUrl = `${this.state.baseUrl}api/v1/best_buddy/student_information/`;
    this.state.GetStudentInformationUrl = `${this.state.baseUrl}api/v1/best_buddy/student_information/?student_id=`;
    this.state.PatchStudentInformationUrl = `${this.state.baseUrl}api/v1/best_buddy/student_information/`;
    this.state.GetUserInformationUrl = `${this.state.baseUrl}api/v1/moodle/users/get_by_field/`;
    this.state.GetUserInfoUrl = `${this.state.baseUrl}api/v1/moodle/users/get_or_create_user_data/`;
    this.state.GetCourseInfoUrl = `${this.state.baseUrl}api/v1/moodle/courses/get_by_field/`;
    this.state.CoursesUrl = `${this.state.baseUrl}api/v1/courses/`;
    this.state.MetricsUrl = `${this.state.baseUrl}api/v1/metrics/`;
    this.state.QuestionsUrl = `${this.state.baseUrl}api/v1/mentor/questions/`;
    this.state.QuestionsBuddyUrl = `${this.state.baseUrl}api/v1/best_buddy/questions/`;
    this.state.GetQuestionsUrl = `${this.state.baseUrl}api/v1/mentor/questions/?student_email=`;
    this.state.GetQuestionsBuddyUrl = `${this.state.baseUrl}api/v1/best_buddy/questions/?student_id=`;
    this.state.UpdateStatusUrl = `${this.state.baseUrl}api/v1/moodle/courses/update_activity_status/`;
    this.state.GetResourcesUrl = `${this.state.baseUrl}api/v1/resources/`;
    this.state.GetUserOauthUrl = `${this.state.baseUrl}api/v1/oauth/redemption/`;
    this.state.UpdateTimeUrl = `${this.state.baseUrl}api/v1/activity/assistants/`;
    this.state.RefreshTokenUrl = `${this.state.baseUrl}api/v1/auth/refresh/`;
    this.state.reportConectionsUrl = `${this.state.baseUrl}api/v1/metrics/mentor_conn/`;

    return { ...this.state };
  }

  getState(): MentorAiState {
    return { ...this.state };
  }

  async loginAdmin(): Promise<void> {
    const user: UserDataLogin = {
      username: this.state.adminUser,
      password: this.state.adminPass,
    };

    const response = await configService.post<LoginResponse>(this.state.loginUrl, user);
    this.state.accessToken = response.tokens.access;
    this.state.refreshToken = response.tokens.refresh;
    configService.setAccessToken(response.tokens.access);
    configService.setRefreshToken(response.tokens.refresh);
  }

  async refreshToken(): Promise<void> {
    if (!this.state.refreshToken) {
      throw new Error('No hay refresh token disponible');
    }

    const response = await configService.post<TokenResponse>(this.state.RefreshTokenUrl, {
      refresh: this.state.refreshToken,
    });
    this.state.accessToken = response.access_token;
    this.state.refreshToken = response.refresh_token;
    configService.setAccessToken(response.access_token);
    configService.setRefreshToken(response.refresh_token);
  }

  async getUserInformationByEmail(email: string): Promise<ApiResponseStudentData> {
    if (!this.state.accessToken) {
      await this.loginAdmin();
    }

    const payload: BaseStructureGetUserInformation = {
      server_id: this.state.serverID,
      field: 'email',
      value: email,
    };

    return configService.postWithBearerToken<ApiResponseStudentData>(
      this.state.GetUserInformationUrl,
      this.state.accessToken || '',
      payload
    );
  }

  async getQuestionsByEmail(email: string): Promise<RootObjectQuestions> {
    if (!this.state.accessToken) {
      await this.loginAdmin();
    }

    return configService.getWithBearerToken<RootObjectQuestions>(
      `${this.state.GetQuestionsUrl}${encodeURIComponent(email)}`,
      this.state.accessToken || ''
    );
  }

  setUserIdentity(firstname: string, lastname: string, email: string, userID?: number): void {
    this.state.firstname = firstname;
    this.state.lastname = lastname;
    this.state.email = email;
    if (userID) {
      this.state.userID = userID;
    }
  }
}

export const mentorAiService = new MentorAiService();
export default mentorAiService;
